import React from 'react';

const AboutBotswalle = () => {
  return (
    <>
      {/* About Botswalle Section */}
      <section id="about" className="py-32 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-4">ABOUT BOTSWALLE - THE SISTERHOOD YOUTH FOUNDATION</h2>
          <div className="section-divider"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-16">
            <div className="flex flex-col justify-center" data-aos="fade-right">
              <p className="text-gray-700 leading-relaxed">
                Botswalle – The Sisterhood Youth Foundation, is a Non - Profit Organization which was established 17 May 2024. 
                In Kliptown, by Kgosigadi Mmatlala Motau which is the Founder, and Co- Founder Kgosi. It is a social development 
                organization focusing on developing young girls ranging from the ages 15 to 21. The program aims to foster the girls 
                on a healing journey devising a support group structure, where they learn to speak about the issues they are faced with. 
                Therefore exposing them to the attention and support they need. The aim of the group is to expose the girls to sistership, 
                the knowledge that they are not alone and that their circumstances today do not have to define their tomorrow. As Botswalle 
                foundation we observed that one of the factors that leads to suicide is the idea that "I am alone" or "no one will understand" 
                and as Botswalle we want to break that stigma. The objective is to teach the girls "Ubuntu/Botho" which essentially is you 
                are because I am. The group will foster healing, spiritual support, counselling and therapy devising theatre of the mind 
                and theatre of the oppressed. Not only that but the girls will have different activities that aid with developing them as 
                they go through navigating being a young woman.
              </p>
            </div>
            <div data-aos="fade-left">
              <img 
                src="/images/image00001.jpeg" 
                alt="Young women in the foundation" 
                className="w-full object-cover h-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section id="vision-mission" className="py-32 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-4">VISION & MISSION</h2>
          <div className="section-divider"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-16">
            <div className="bg-white p-12 shadow-md h-full" data-aos="fade-up" data-aos-delay="100">
              <h3 className="text-xl font-light mb-6 tracking-wide">VISION</h3>
              <p className="text-gray-700 leading-relaxed mb-6">
                Botswalle journeys in impacting the lives of young pupils by impowering and echoeing the message of mental health. 
                For a healthy mind equals a healthy life. Thus, producing a healthy, mindful and positive society. whereby, life will 
                always be challenging although with a healthy mindset anything can be overcome.
              </p>
              
              <h3 className="text-xl font-light mb-6 tracking-wide mt-8">MISSION</h3>
              <p className="text-gray-700 leading-relaxed">
                We aim to reflect the African saying "Botho/Ubuntu" on the youth of South Africa and beyond the boarders of Africa. 
                To say that "I AM" because "YOU ARE". encouraging a life-long relation of sisterhood & friendships, a network of strong 
                willed girls, young women, and mature women who support each other.
              </p>
            </div>
            <div data-aos="fade-up" data-aos-delay="200">
              <img 
                src="/images/image00002.jpeg" 
                alt="Vision and Mission representation" 
                className="w-full object-cover h-full"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutBotswalle;